import pkg from '../../package.json';

export const environment = {
  production: import.meta.env.PROD,
  NAME: pkg.name,
  VERSION: pkg.version,
  FRONT_END: import.meta.env.VITE_FRONT_END as string,
  TGC_USER: import.meta.env.VITE_TGC_USER as string,
  SECURE_ROUTES: (import.meta.env.VITE_SECURE_ROUTES as string).split(','),
  OAUTH_CLIENT_ID: import.meta.env.VITE_OAUTH_CLIENT_ID as string,
};
